import React, {useState} from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  background-color: #6A8CAF;
  padding:45px 15px 20px;

  @media (min-width: 1024px) {
  padding: 50px 60px 20px;
  }
`;

const Title = styled.h2`
  color: #e0e0e0ff;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: subpixel-antialiased;
  text-transform: uppercase;
  letter-spacing: 6px;
  margin: 0 0 50px 0;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 20px;

  @media (min-width: 1024px) {
    margin: 0 0 50px 0;
    align-self: flex-end;
    width: 400px;
    height: 380px;
  }
`;

const FieldInput = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;


  &::after {
    content: '';
    position: absolute;
    bottom: 1px;
    left: 1px;
    right: 0.4em;
    height: 1px;
    background-color: #e0e0e0ff;
    transition: background-color 0.15s ease, transform 0.2s ease;
    pointer-events: none;
  }
`;

const FullContainer = styled.div`
    margin-top: 30px;
    margin-bottom: 50px;

    @media (min-width: 1024px) {
      margin-bottom: unset;
      width: 320px
    }
`;

const FieldTextArea = styled.div`
  border: 1px solid #e0e0e0ff;
`;

const BaseInputStyles = `
width: -webkit-fill-available;
color: white;
font-family: Lato;
border: none;
padding: 10px 0 8px;
font-size: 15px;
background: transparent;
outline: none;
transition: border-color 0.15s ease, box-shadow 0.12s ease;


&::placeholder {
font-family: Lato;
text-transform: uppercase;
color: #e0e0e0ff;
}


&:focus {
outline: none;
}


&:invalid {
border-bottom-color: #d9534f;
}
`;


const Input = styled.input`
${BaseInputStyles}
`;


const TextArea = styled.textarea`
${BaseInputStyles}
padding: 10px 0 10px 10px;
height: 80px;
`;

const Button = styled.button`
  font-family: 'Lato', sans-serif;
  height: 50px;
  background: #f3f2eaff;
  text-transform: uppercase;
  outline: none;
  color: #3D3D3D;
  width: 100%;
  padding: 0;
  margin: -5px 0px 0px 0px;
  outline:none;
  cursor: pointer;
  border: solid 1px #b3aca7;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;

  &:hover {
    background: #3D3D3D;
    color: #f3f2eaff;
  }
`;

const SuccessMessage = styled.div`
  text-align: center;
  padding: 4rem 2rem;

  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  @media (min-width: 1024px) {
    height: 380px;
  }
`;

const Label = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const Container = styled.div `
display: flex;
flex-direction: column;
justify-content: space-between;
a {
  text-decoration: none;
  color: #e0e0e0ff;
  font-family: Lato;
  font-size: 16px;
}

p {
  margin-top: 5px;
  color: #e0e0e0ff;
}

  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

const TextAreaTitle = styled.p`
  text-transform: uppercase;
  color: #bdbdbd;
  font-size: 15px;
  margin: 0 0 -16px 0;
`;

const YearCopyright = styled.div`
  color: #bdbdbd;
  font-family: Lato;
  font-size: 14px;
  margin-top: 40px;

  @media (min-width: 1024px) {
    text-align: right;
    margin-top: 0;
  }
`;


const Contact = () => {
    const { t, i18n } = useTranslation();
  
    const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

    const [status, setStatus] = useState("idle"); // idle | submitting | success | error

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("submitting");

  try {
      const response = await fetch("https://formspree.io/f/xjkapdoo", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({ firstName: "", lastName: "", email: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Form error:", error);
      setStatus("error");
    }
  };

  const currentYear = new Date().getFullYear();

  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/aurelie-capsicode/appel-decouverte?background_color=f3f2ea&text_color=3d3d3d&primary_color=699fd6",
      });
    } else {
      console.error("Calendly is not loaded");
    }
  };
  return (
    <Wrapper id="contact">
      <Title>Contact</Title>
      <Container>
        <div>
          <p>Aurélie Plane</p>
              <a href='mailto:contact@aurelieplane.com?subject=👋'>
                contact@aurelieplane.com
              </a>
              <p>+33 (0)663 68 65 40</p>

            <FullContainer>
              <Button 
                onClick={openCalendly}>Réserve ton appel découverte
              </Button>
            </FullContainer>
        </div>

        {status === "success" ? (
          <SuccessMessage>
            <h3>Message sent.</h3>
            <p>Thanks for reaching out. I’ll reply soon!</p>
          </SuccessMessage>
        ) : (
        <Form onSubmit={handleSubmit} autoComplete="on" noValidate>
          <FieldInput>
            <Label htmlFor="name">Name</Label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    autoComplete="name"
                    placeholder={t("form.name")}
                  />
              </FieldInput>

            <FieldInput>
              <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  placeholder="Email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                />
            </FieldInput>

          <TextAreaTitle>Message:</TextAreaTitle>
          <Label htmlFor="message">Message</Label>
          <FieldTextArea>
            <TextArea
              id="message"
              name="message"
              required
              value={formData.message}
              onChange={handleChange}
            />
          </FieldTextArea>

          <Button type="submit">{t("form.submit")}</Button>
        </Form>
      )}
      </Container>
      <YearCopyright>© {currentYear} Aurélie Plane</YearCopyright>
    </Wrapper>
  );
};

export default Contact;
